import jwtDecode from 'jwt-decode';

export default function getUser() {
    // 1. Check if token exists
    const existingTokens = localStorage.getItem('tokens');
    if (!existingTokens) {
        return null;   // No user logged in
    }

    let decodedToken;
    try {
        // 2. Parse JSON and decode the JWT
        const token = JSON.parse(existingTokens);
        decodedToken = jwtDecode(token);
    } catch (err) {
        console.error("Invalid token:", err);
        return null;   // Treat invalid token as not logged in
    }

    // 3. Extract fields safely
    return {
        role: decodedToken.role || null,
        user: decodedToken.user || null,
        cleaner: decodedToken.cleaner || null,
        visitId: decodedToken.visitId || null,
        expires: decodedToken.expires || null
    };
}
